import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { environment } from '../../../environments/environment';
import { PrimaryButtonComponent } from '../../basic/buttons/primary-button/primary-button.component';
import { BoardHolderService } from '../../core/board/board.holder.service';
import { WorkspaceHolderService } from '../../core/workspace/workspace.holder.service';
import { UpdateSubscriptionButtonComponent } from '../../domain/membership/update-subscription-button/update-subscription-button.component';
import { BasicPageComponent } from '../_shared/basic-page/basic-page.component';
import { MainSidebarComponent } from '../_shared/main-sidebar/main-sidebar.component';
import { UserClerkService } from './../../core/user/user-clerk.service';

@Component({
  selector: 'app-pricing',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzIconModule,
    NzInputModule,
    NzButtonModule,
    NzTableModule,
    NzPopoverModule,
    NzUploadModule,
    NzModalModule,
    NzPopconfirmModule,

    MatTooltip,

    BasicPageComponent,
    MainSidebarComponent,
    PrimaryButtonComponent,
    UpdateSubscriptionButtonComponent,
  ],
  templateUrl: './pricing.component.html',
  styleUrl: './pricing.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingComponent {
  constructor(
    private userClerkService: UserClerkService,
    private workspaceHolderService: WorkspaceHolderService,
    private boardHolderService: BoardHolderService
  ) {}

  get user() {
    return this.userClerkService.getUser();
  }

  subscriptionId = computed(() => {
    return this.workspaceHolderService.subscriptionId();
  });

  primaryEmail = computed(() => {
    return this.userClerkService.getUser()?.primaryEmailAddress?.emailAddress;
  });

  getClientReferenceId() {
    const result = `${this.user!.id}___${this.workspaceHolderService.currentWorkspace().id}___${this.boardHolderService.myPersonalBoard()!.id}`;

    console.log('----reference id:', result);
    return result;
  }

  getPricingTableId() {
    return environment.stripe.pricingTableId;
  }

  getKey() {
    return environment.stripe.publishableKey;
  }
}
